import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'val-auth-log-in',
  template: `<div>
    <img src="assets/images/loading.svg" alt="loading" />
  </div>`,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLogInComponent {
  constructor() {}
}
